const enum TriggerActionType {
    EXHIBIT = 'exhibit',
    FACILITY = 'facility',
    MESSAGE = 'message',
    OFFER = 'offer',
    URL = 'url',
    UNKNOWN = 'unknown'
}

export default TriggerActionType